<template>
  <a-modal
    v-model="visible"
    :width="720"
    :mask-closable="false"
    wrap-class-name="config-success-modal"
    @ok="hideModal"
    @cancel="hideModal"
  >
    <div class="top">
      <i class="iconfont iconicon-test33 success-icon" />{{ $t('message["23"]') }}
    </div>
    <p class="prompt-text">
      {{ $t('message["490"]') }}
      <a
        href="https://help.westartrack.com/faq/d_5da975ad4db67f2b34706f3c.html"
        target="_blank"
        class="link-help"
      >{{ $t('message["86"]') }}</a>
    </p>
    <div class="link-url">
      {{ saveResult }}
    </div>
    <div
      slot="footer"
      class="footer clearfix"
    >
      <a-button
        type="primary"
        @click="handleCopyUrl"
      >
        {{ $t('message["318"]') }}
      </a-button>
      <div
        v-if="copySuccess"
        class="success-box"
      >
        <i class="iconfont iconicon-test33 success-icon" />
        {{ $t('message["321"]') }}
      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    saveResult: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      visible: false,
      copySuccess: false
    }
  },
  methods: {
    showModal () {
      this.visible = true
    },
    hideModal () {
      this.visible = false
      this.copySuccess = false
      this.$router.push({ name: 'smartForm' })
    },
    copyValue (val) {
      // 如果这里换为 input 则不支持换行
      var temp = document.createElement('textarea')
      temp.value = val
      document.body.appendChild(temp)
      temp.select() // 选择对象
      document.execCommand('Copy') // 执行浏览器复制命令
      temp.style.display = 'none'
      console.log('复制成功')
      this.copySuccess = true
    },
    handleCopyUrl () {
      this.copyValue(this.saveResult)
    }
  }
}
</script>
<style lang="scss">
.config-success-modal {
  .ant-modal {
    // width: 720px;
  }
  .ant-modal-header {
    display: none;
  }
  .ant-modal-body {
    padding: 34px 64px 0 64px;
  }
  .top {
    position: relative;
    margin-bottom: 8px;
    .success-icon {
      position: absolute;
      top: -8px;
      left: -40px;
      font-size: 24px;
      color: #42c27e;
    }
    font-size: 14px;
    font-weight: bold;
    color: #333;
  }
  .prompt-text {
    color: #666;
  }
  .link-help {
    margin-left: 16px;
    color: #4ca0f2;
  }
  .link-url {
    line-height: 1;
    margin: 8px 0;
    padding: 12px;
    background: #f7f7f7;
    border-radius: 4px;
    word-break: break-all;
    border: 1px solid #e0e0e0;
  }
  .ant-modal-footer {
    border-top: none;
    padding: 0;
    padding-bottom: 24px;
  }
  .footer {
    padding-left: 64px;
    .ant-btn {
      float: left;
    }
    .success-box {
      float: left;
      height: 32px;
      line-height: 32px;
      margin-left: 16px;
      .success-icon {
        font-size: 16px;
        color: #42c27e;
      }
    }
  }
}
</style>
